import { styled } from '@mui/material/styles';

export const CargoSelectionResultStyledContainer = styled('div')`
  margin-top: 10px;
  
  .selection-error {
    font-size: 16px;
    font-weight: 600;
    color: #f15642;
  }
  .selection-result-wrapper {
    border-radius: 8px;
    border: 2px solid #0eab70;
    padding: 16px;
    box-shadow: 0px 0px 16px 10px rgba(14, 171, 112, 0.24);
  }

  .selection-result-control {
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }

  .selection-result-title {
    font-size: 20px;
    font-weight: 600;
  }

  .selection-result-apply-btn {
    font-weight: 600;
    color: #fff;
  }

  .selection-result-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 16px;
    margin-top: 16px;
  }

  .selection-result-item {
    padding: 5px 10px;
    border-radius: 8px;
    border: 1px solid #dbe0ec;
    position: relative;

    &__cargo {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &.has-pallets {
        &:before {
          position: absolute;
          content: '';
          width: 100%;
          height: 1px;
          background-color: #dbe0ec;
          top: 35px;
        }
      }
    }

    &__title {
      font-weight: 600;
    }

    &__icon {
      display: flex;
      align-items: center;

      svg {
        font-size: 18px;
      }
    }

    &__pallets {
      display: flex;
      margin-top: 10px;
      flex-direction: column;
    }

    &__pallets-title {
      text-align: center;
      font-size: 14px;
      font-weight: 600;
    }

    &__pallet {
      font-size: 14px;
    }
  }
`;
